// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useState, useContext, Fragment, useMemo,
  useEffect} from 'react';
import {useHistory} from 'react-router';
import cn from 'classnames';
import etask from 'zetask';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Change_password_form_new}
    from '../../../../hola/pub/ui/cp/change_password_form';
import {Modal} from '../../../../hola/pub/lib/modal';
import {App_context} from 'hola_app_context';
import Icon_logout from '../../img/icons/logout.svg';
import Icon_trash from '../../img/icons/24/trash.svg';
import {Button} from '../../../../hola/pub/lib/button';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import {Payment_history} from './payment_history';
import {use_pathname} from '../../../../hola/pub/lib/use_pathname';
import {use_translation_v} from '../../../../hola/pub/lib/trans_v';
import {use_app_context} from '../../lib/app_context';
import Icon_card_failed from '../../img/icons/24/bank_card_crossed.svg';
import {t_order} from '../../../../hola/pub/ui/pro/cp/orders';
import {get_payment_renew_url} from './utils';
import {Popup} from '../popup/popup';
import storage from '/util/storage.js';
import {Account_settings} from './account_settings';
import {use_debug_ui} from '../../../../hola/pub/lib/debug';
import {Kyc_account} from './kyc/kyc';
import {use_toast} from '../../../../shared/ui/toast';
import {use_etask} from '../../../../hola/pub/lib/use_etask';
import {api} from '../../lib/api';
import {Action_menu} from './action_menu/action_menu';
import {cc_map, cc_map_small} from '../cc_icons';
import {No_account} from './no_account';
import styles from './my_account.module.less';

export {cc_map, cc_map_small};

export const get_card_info = payment=>{
    if (!payment)
        return null;
    const {ccard_exp_month, ccard_exp_year, ccard_last4,
        ccard_type, name} = payment;
    const cc = cc_map[ccard_type]||{};
    return {
        icon: cc.icon,
        title: `${cc.title} **** ${ccard_last4}`,
        name: `(${name})`,
        expired: `Exp: ${ccard_exp_month}/${ccard_exp_year}`,
    };
};

const Logout_confirmation = ({set_is_logout_open})=>{
    const {theme} = useContext(Settings_context);
    const {T, t} = use_translation_v({no_defaults: true});
    const logout = ()=>etask(function*(){
        yield fetch('/users/logout/inline', {method: 'POST',
            xhrFields: {withCredentials: true}});
        storage.clr_all();
        location.href = '/';
    });
    return <div className={styles.logout_confirmation}>
      <p className={cn(theme.p16, theme.med, theme.color_n700,
        styles.heading)}>
        <T>Ready to Head Out?</T>
      </p>
      <p className={cn(theme.p14, theme.med, theme.color_n400)}>
        <T>Are you sure you want to log out? Hit "Log Out" to go, or "Stay
          Here" if you're not quite done.</T>
      </p>
      <div className={styles.btn_container}>
        <Button caption={t('Log out')} round={false} color='transparent'
          on_click={logout}/>
        <Button caption={t('Stay Here')} round={false}
          cls={styles.stay_here_btn}
          on_click={()=>set_is_logout_open(false)}/>
      </div>
    </div>;
};

export const My_account = ({auth})=>{
    const {theme} = useContext(Settings_context);
    const {T, t} = use_translation_v({no_defaults: true});
    const {user} = useContext(App_context);
    const history = useHistory();
    const [modal, set_modal] = useState('');
    const {screen} = use_screen();
    const {params} = use_pathname();
    const [is_logout_open, set_is_logout_open] = useState(false);
    const debug_kyc = use_debug_ui('kyc');
    const email = user?.emails ? user?.emails[0].value : null;
      const get_current_view = ()=>{
        if (!params.section)
            return 'main';
        if (params.section == 'settings')
            return 'settings';
        if (params.token)
            return `product_${params.section}`;
        return 'payment_history';
    };
    const handle_back = ()=>{
      if (params.token)
      {
          history.push(`/dashboard/page/account/section/${params.section}`);
          return;
      }
      history.push('/dashboard/page/account');
    };
    const current_view = get_current_view();
    return <div className={cn(styles.my_account,
      current_view == 'settings' && styles.my_account_settings)}>
      <Modal lighter_close_btn={true}
        is_open={is_logout_open} width={403} paddingless={true}
        on_close={()=>set_is_logout_open(false)}
        on_overlay_click={()=>set_is_logout_open(false)}>
        <Logout_confirmation set_is_logout_open={set_is_logout_open}/>
      </Modal>
      {current_view == 'main' ? <>
        <h4 className={cn(styles.mb32, styles.account_title)}>
          <T>My account</T>
        </h4>
        {user ? <Fragment>
          <section className={styles.account_section}>
            <p className={
              cn(theme.color_n700, theme.med, theme.p16, styles.title)}>
              <T>Personal details</T></p>
            <div className={styles.details_container}>
              {user.provider == 'github' && !email ? <Fragment>
                <p className={cn(styles.detail, theme.p4, theme.color_n400)}>
                  <T>Github account</T></p>
                <div className={styles.details_val_wrapper}>
                  <a className={cn(styles.github_link, theme.med, theme.p3,
                    theme.color_n800)}>{user.profileUrl}</a>
                  <Fragment><Button cls={styles.logout} caption={
                    <Fragment>
                      <Icon_logout/>
                      <span className={theme.u4}><T>Log out</T></span>
                    </Fragment>}
                    color={'transparent_grey'} size={'sm'}
                    on_click={()=>{ set_is_logout_open(true); }}/>
                  </Fragment>
                </div>
              </Fragment> : <Fragment>
                <p className={cn(styles.detail, theme.p4, theme.color_n400)}>
                  <T>Email</T></p>
                <div className={styles.details_val_wrapper}>
                  <p className={cn(styles.detail_val, theme.med, theme.p3,
                    theme.color_n800)}>{email}</p>
                  <Fragment><Button cls={styles.logout} caption={
                    <Fragment>
                      <Icon_logout/>
                      <span className={theme.u4}><T>Log out</T></span>
                    </Fragment>}
                    color={'transparent_grey'} size={'sm'}
                    on_click={()=>{ set_is_logout_open(true); }}/>
                  </Fragment>
                </div>
              </Fragment>}
              {user.kyc_approved_email && <Fragment>
                <p className={cn(styles.detail, theme.p4, theme.color_n400)}>
                  <T>KYC approved email</T></p>
                <p className={cn(styles.detail_val, theme.med, theme.p3,
                  theme.color_n800)}>{user.kyc_approved_email}</p>
              </Fragment>}
            </div>
          </section>
          <Plans_payments/>
          <Payment_methods/>
          <section className={styles.account_section}>
            <p className={
              cn(theme.color_n700, theme.med, theme.p16, styles.title)}>
              <T>Account settings</T></p>
            <div className={cn(styles.details_container,
              styles.container_direction)}>
              <p className={cn(theme.p14, theme.color_n500)}>
                <T>Manage your password and account</T>
              </p>
              <Button color="white" size='sm'
                caption={t('Manage account')}
                cls={styles.change_pass_btn}
                inline round={false}
                on_click={()=>{
                  history.push('/dashboard/page/account/section/settings');
                }}/>
              <Modal is_open={modal == 'change_pass'} cls={styles.modal}
                on_close={()=>set_modal(null)} content_when_open
                width={screen == 'xs' ? 335 : 400}>
                <Change_password_form_new
                  on_success={()=>set_modal('change_pass_done')}
                  email={email}/>
              </Modal>
            </div>
          </section>
          {debug_kyc && <section className={styles.account_section}>
            <Kyc_account />
          </section>}
        </Fragment> : <No_account auth={auth}/>}
      </>
        : current_view == 'settings' ?
          <Account_settings on_back={handle_back} modal={modal}
            set_modal={set_modal} email={email}/>
        : <Payment_history on_back={handle_back} user={user?.hola_uid}/>
      }
    </div>;
};

const Plans_payments = ()=>{
    const {T, t} = use_translation_v({no_defaults: true});
    const history = useHistory();
    const {theme} = useContext(Settings_context);
    const {dashboard, renew_error_orders,
        renew_error_expired_in_day} = use_app_context();
    const {info} = dashboard;
    const {account, orders} = info;
    const show_payment_error = renew_error_orders?.length > 0
        && account?.payment_methods?.some(p=>p.error);
    return orders && <section className={styles.account_section}>
      <p className={
        cn(theme.color_n700, theme.p16, theme.med, styles.title)}>
        <T>Plans and payments</T></p>
      <div className={cn(styles.details_container,
        styles.container_direction)}>
        <p className={cn(theme.p14, theme.color_n500)}>
          <T>
          View and update your plans, payment history and receipts
          </T>
        </p>
        <Button color="white" size='sm'
          caption={t('View plans')}
          cls={cn(styles.change_pass_btn, styles.view_history_btn)}
          inline round={false}
          on_click={()=>
            history.push('/dashboard/page/account/section/active')}
          />
      </div>
      {show_payment_error && <Popup show_on_hover position="right"
        wrapper_cls={styles.payment_failed_wrapper}
        popup_cls={styles.payment_failed_popup_dialog}
        is_always_shown={true}>
        <Payment_failed_popup order={renew_error_orders[0]}
          immediate={renew_error_expired_in_day} />
      </Popup>
      }
    </section>;
};

const Payment_methods = ()=>{
    const {theme} = useContext(Settings_context);
    const {dashboard} = use_app_context();
    const {payment_methods = []} = dashboard.info?.account ?? {};
    const {toast} = use_toast();
    const {exec, state} = use_etask<[string],
          {success: boolean, error: string}>(api.delete_payment_method);
    useEffect(()=>{
      if (state?.data?.error)
          toast({type: 'error', msg: state.data.error});
      if (state?.data?.success)
      {
          toast({type: 'success', msg: 'Payment method removed'});
          dashboard.dispatch({type: 'refresh_account_data'});
      }
    }, [state?.data?.error, state?.data?.success]);
    const payments = useMemo(()=>payment_methods?.filter(pm=>pm.id)
        .sort((a, b)=>Number(!!a.error) - Number(!!b.error)),
    [payment_methods]);
    if (payments.length == 0)
        return null;
    const content = <section className={styles.account_section}>
      <p className={cn(theme.color_n700, theme.p16, theme.med,
        styles.title)}>
        Payment methods</p>
      <div className={cn(styles.details_container)}>
        {payments.map((pm, i)=>
          <div className={cn(styles.card_info, pm.error && styles.error)}
            key={pm.id+i}>
            {cc_map_small[pm.card_type]?.icon}
            <p className={cn(theme.p14, theme.bold, theme.color_n700)}>
              {pm.card_lbl}</p>
            <p className={cn(theme.p12, theme.color_n500)}>
              Exp: {pm.card_exp_lbl}</p>
            {pm.error && <span className={cn(styles.badge, styles.error)}>
                Declined</span>}
            <Action_menu
              wrapper_cls={styles.pm_menu_wrapper} menu_cls={styles.pm_menu}
              item_cls={cn(theme.p14, styles.pm_menu_item)}
              position={'left'} items={[{
                id: 'remove',
                text: 'Remove payment method',
                icon: Icon_trash,
                on_click: ()=>!state.loading ? exec(pm.id) : null,
              }]}/>
        </div>)}
      </div>
    </section>;
    return content;
};
interface i_payment_failed_popup_props {
    order: t_order;
    immediate: boolean;
}
const Payment_failed_popup = (props: i_payment_failed_popup_props)=>{
    const {theme} = useContext(Settings_context);
    const history = useHistory();
    const title = props.immediate ?
      'Last chance to keep your proxies' :
      'We couldn\'t process your payment';
    const text = props.immediate ?
      `Update your payment details now to avoid permanent loss
      of access to your proxies`:
      `Please update your payment details to
      avoid losing access to your proxies permanently`;
    const update_url = get_payment_renew_url(props.order);
    const renew_update_cc = ()=>{
        storage.set('renew_update_cc_orig', location.pathname);
        history.push(update_url);
    };
    return <div className={cn(styles.payment_failed_popup)}>
      <div className={
        cn(styles.payment_failed_icon, props.immediate && styles.error)}>
          <Icon_card_failed />
      </div>
      <div className={styles.content}>
        <div>
          <p className={cn(theme.p14, theme.bold, theme.color_n700,
            styles.mb8)}>{title}</p>
          <p className={cn(theme.p12, theme.color_n600)}>{text}</p>
        </div>
        <Button on_click={renew_update_cc} fit={false}
          caption="Update payment details" color="black" size="xs"
          round={false}/>
      </div>
    </div>;
};
